<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Dossiers importation",
          icon: "bi bi-folder2-open",
          route: "consignments-index",
        },
        {
          label: "Nouveau dossier",
          icon: "bi bi-file-earmark-plus-fill",
          route: "consignments-create",
        },
        {
          label: "Coûts dossiers",
          icon: "bi bi-calculator-fill",
          route: "consignment-costs-index",
        },
        {
          label: "Ajouter coût",
          icon: "bi bi-plus-lg",
          route: "consignment-costs-create",
        },
      ],
    };
  },
};
</script>
